import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  ADMIN_SET_VENDOR_ONBOARD_DETAILS,
  ADMIN_SET_VENDOR_ONBOARD_CHAIN,
  ADMIN_SET_VENDOR_SUBCRIPTION,
} from "../../types";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/******************************************
 * @DESC - GET VENDOR DETAILS INFORMATION
 *****************************************/
export const sa_get_update_whole_vendor_onboarding =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let add_restaurant_data = await axios.post(
        `${serverApi}/restaurant`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_restaurant_data.data) {
        dispatch({
          type: ADMIN_SET_VENDOR_ONBOARD_DETAILS,
          payload: add_restaurant_data.data.restaurant._id
            ? add_restaurant_data.data.restaurant
            : add_restaurant_data.data.restaurant[0],
        });
        dispatch({
          type: ADMIN_SET_VENDOR_ONBOARD_CHAIN,
          payload: add_restaurant_data.data.restaurantchain,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/******************************************
 * @DESC - GET SUBSCRIPTION DETAILS INFORMATION
 *****************************************/
export const sa_get_update_whole_vendor_subscription =
  (vendor_id, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let get_new_subscription_record = await axios.get(
        `${serverApi}/admin/subscription/${vendor_id}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_new_subscription_record.status === 200) {
        dispatch({
          type: ADMIN_SET_VENDOR_SUBCRIPTION,
          payload: get_new_subscription_record.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
